export const displayNotificationInUI = (title, body, icon) => {
    let notificationContainer = document.getElementById("notification-container");
    if (!notificationContainer) {
        notificationContainer = document.createElement("div");
        notificationContainer.id = "notification-container";
        notificationContainer.style.position = "fixed";
        notificationContainer.style.top = "10px";
        notificationContainer.style.right = "10px";
        notificationContainer.style.zIndex = "1000";
        document.body.appendChild(notificationContainer);
    }

    const notificationElement = document.createElement("div");
    notificationElement.style.border = "1px solid #ddd";
    notificationElement.style.borderRadius = "5px";
    notificationElement.style.padding = "10px";
    notificationElement.style.marginBottom = "10px";
    notificationElement.style.backgroundColor = "#fff";
    notificationElement.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
    notificationElement.style.display = "flex";
    notificationElement.style.alignItems = "center";
    notificationElement.style.width = "300px";
    notificationElement.style.animation = "slideIn 0.3s ease-out";

    const style = document.createElement('style');
    style.textContent = `
        @keyframes slideIn {
            from { transform: translateX(100%); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
        }
    `;
    document.head.appendChild(style);

    const notificationIcon = document.createElement("img");
    notificationIcon.src = icon || "/logo192.png";
    notificationIcon.style.width = "40px";
    notificationIcon.style.height = "40px";
    notificationIcon.style.marginRight = "10px";
    notificationIcon.style.borderRadius = "50%";

    const notificationText = document.createElement("div");
    notificationText.innerHTML = `
        <strong>${title}</strong><br />
        <span>${body}</span>
    `;

    notificationElement.appendChild(notificationIcon);
    notificationElement.appendChild(notificationText);
    notificationContainer.appendChild(notificationElement);

    setTimeout(() => {
        notificationElement.style.animation = "slideOut 0.3s ease-in";
        setTimeout(() => {
            notificationElement.remove();
            if (notificationContainer.childNodes.length === 0) {
                notificationContainer.remove();
            }
        }, 300);
    }, 15000);
};